module.exports = "<div class=\"alert alert-danger\" *ngIf=\"errors?.length > 0\">\n    <ul>\n        <li *ngFor=\"let error of errors\">\n            {{error}}\n        </li>\n    </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/forms/error-summary.component.html
// module id = ../../../../../src/app/shared/forms/error-summary.component.html
// module chunks = main